<template>
    <div>
        <mu-float-button icon="add" style="vertical-align:middle;"/> 浮动按钮
    </div>
</template>
<script>
export default {
    name: 'floatingActionButton'
}
</script>



// WEBPACK FOOTER //
// floatingActionButton.vue?684357ec